// extracted by mini-css-extract-plugin
export default {"control":"control_control__l8La8","button":"control_button__+hfW2"};